<template>
  <div class="main-header">
    <div class="header">
      <h2>
        <i class="el-icon-s-unfold" v-if="menuData.collapse" @click="switchCollapseMenu(null)"></i>
        <i class="el-icon-s-fold" v-else @click="switchCollapseMenu(null)"></i>
        {{title}}
      </h2>
      <div class="user">
        <span v-if="temp !== '' && temp !== null">温度：{{temp}}</span> <span v-if="humi !== '' && humi !== null">湿度：{{humi}} &nbsp;&nbsp;</span>
        <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                <img v-if="sysUserInfo != null" :src="sysUserInfo.avatar == null ? '/static/avatar/man.png' : sysUserInfo.avatar" alt=""><b>{{ JSON.parse(sysUserInfo).userName }}</b><i class="el-icon-arrow-down el-icon--right"></i>
              </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div class="user2">
        <!-- 消息按钮 -->
        <el-dropdown @command="handleCommand" placement="bottom-end">
          <span class="el-dropdown-link">
            <el-badge :value="unreadCount" class="message-icon" :max="99">
              <i class="el-icon-bell"></i>
            </el-badge>
          </span>
          <el-dropdown-menu slot="dropdown" class="message-dropdown">
            <el-table :data="messages" border height="300" style="width: 400px">
              <el-table-column prop="title" label="消息内容" width="280px"></el-table-column>
              <el-table-column prop="time" label="时间"></el-table-column>
            </el-table>
            <div class="dropdown-footer">
              <el-button size="small" @click="viewMore">查看更多</el-button>
              <el-button size="small" type="primary" @click="clearMessages">清空消息</el-button>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../store/index.js'
import { mapState, mapMutations } from 'vuex'
import GlobalWindow from './GlobalWindow'
import axios from 'axios'
export default {
  name: 'Header',
  components: { GlobalWindow },
  computed: {
    ...mapState(['menuData', 'sysUserInfo']), // store变量
    title () {
      return this.$route.meta.title
    },
    remark () {
      return JSON.parse(this.$store.state.sysUserInfo).remark
    }
  },
  data () {
    return {
      unreadCount: 0, // 未读消息数量
      messages: [],
      device: '',
      temp: '',
      humi: ''
    }
  },
  beforeDestroy () {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
  created () {
    this.getCheckPriceResultList()
    this.getDeviceTemp()
    // 设置定时器，每10秒执行一次
    if (this.remark === '1') {
      this.intervalId = setInterval(() => {
        this.getDeviceTemp()
      }, 1200000) // 10000毫秒 = 10秒
    }
  },
  methods: {
    ...mapMutations(['setSysUserinfo', 'switchCollapseMenu']), // store方法
    getDeviceTemp () {
      if (this.remark === '1') {
        axios.post('api/sysUser/getTempAndHumi').then((res) => {
          if (res && res.data.code === 200) {
            this.device = res.data.result.device
            this.temp = res.data.result.temp
            this.humi = res.data.result.humi
            if (this.temp > 30 || this.humi > 60) {
              this.open('温度不能超30度！当前温度值为：' + this.temp + '    湿度不能超60度！当前湿度值为：' + this.humi)
            }
          }
        }).catch(function (err) {
          console.log(err)
        })
      }
    },
    open (info) {
      this.$notify({
        title: '报警',
        message: info,
        type: 'warning',
        position: 'bottom-right',
        dangerouslyUseHTMLString: true, // 启用 HTML 渲染
        duration: 60000 // 设置停留时间为 15 秒
      })
    },
    // 退出登录
    logout () {
      this.$router.push({name: 'login'})
      // this.setRegisterUserInfo(null)
      store.commit('logout')
    },
    getCheckPriceResultList () {
      axios.post('/api/orderInfo/getCheckPriceResultList').then((res) => {
        if (res && res.data.code === 200) {
          this.unreadCount = res.data.result.length
          if (res.data.result.length > 0) {
            this.messages = res.data.result.map((item) => {
              return {
                title: item.split('日期：')[0],
                time: item.split('日期：')[1]
              }
            })
          }
        }
      }).catch(function (err) {
        console.log(err)
      })
    },
    handleCommand (command) {
      console.log('点击消息操作', command)
    },
    viewMore () {
      console.log('跳转到更多消息页面')
    },
    clearMessages () {
      this.messages = []
      this.unreadCount = 0
      console.log('清空消息')
      axios.post('/api/orderInfo/clearMessages').then((res) => {
        if (res && res.data.code === 200) {
          this.$message.success(res.data.result)
        }
      }).catch(function (err) {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/style/variable";
.header {
  overflow: hidden;
  padding: 0 25px;
  background: #fff;
  height: 100%;
  display: flex;
  h2 {
    width: 50%;
    flex-shrink: 0;
    line-height: @header-height;
    font-size: 19px;
    font-weight: 600;
    color: #606263;
    display: inline;
    & > i {
      font-size: 20px;
      margin-right: 12px;
    }
  }
  .user {
    width: 45%;
    flex-shrink: 0;
    text-align: right;
    .el-dropdown {
      top: 2px;
    }
    img {
      width: 32px;
      position: relative;
      top: 10px;
      margin-right: 10px;
    }
  }
}
.user2 {
  padding-top: 20px;
  padding-left: 20px;
  // 下拉菜单框
  .el-dropdown-menu {
    width: 340px;
    .el-dropdown-menu__item:hover {
      background: #E3EDFB;
      color: @primary-color;
    }
  }
}

</style>




// WEBPACK FOOTER //
// src/components/common/Header.vue